import React from 'react';
import { FaPhone } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";
import { LuClock4 } from "react-icons/lu";
import { FaBook } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";

//Inconos genericos que usamos por toda la web
const IconosGenerales = (props) => {

  const iconSize = props.contacto ? '27' : props.curso ? '35' : '12';

  const iconStyle = {
    margin: '0px 5px',
    fontSize: `${iconSize}px`,
    color: props.contacto || props.curso ? '#EE805D' : '#4a4a4a'

  };

  const iconStyle2 = {
    margin: '0px 5px',
    fontSize: `17px`,
    color: "#EE805D"
  };

  switch (props.id) {
    case 'telefono':
      return <FaPhone style={iconStyle} />;
    case 'correo':
      return <IoMdMail style={iconStyle} />;
    case 'reloj':
      return <LuClock4 style={iconStyle2} />;
    case 'libro':
      return <FaBook style={iconStyle} />;
    case 'check':
      return <FaCheck style={iconStyle2} />;
    default:
      return null;
  }
};

export default IconosGenerales;
